<template>
  <footer>
    <div class="base-info view-width">
      <!-- 新版门户不需要 -->
      <ul class="links" v-if="false">
        <li class="link-item" style="width: 300px">
          <span
            class="el-icon-phone"
            style="width: 50px; height: 50px; border-radius: 50%; border: solid 1px #eee; font-size: 30px; text-align: center; line-height: 50px"
          ></span>
          <p style="margin-top: 30px;">
            联系电话：0471-3149262
          </p>
        </li>
        <li class="link-item" style="width: 300px;">
          <span
            class="el-icon-message"
            style="width: 50px; height: 50px; border-radius: 50%; border: solid 1px #eee; font-size: 30px; text-align: center; line-height: 50px"
          ></span>
          <p style="margin-top: 30px;">
            联系邮箱：business@qylsbl.com
          </p>
        </li>
        <li class="link-item" v-for="(link, i) in links" :key="i" v-if="false">
          <a
            :href="item.href"
            target="_blank"
            :class="{ 'link-title': index === 0 }"
            :key="`${i}_${index}`"
            v-for="(item, index) in link"
          >
            {{ item.name }}
          </a>
        </li>
      </ul>
      <!--<div class="code">-->
      <!--<img class="code-img" :src="codeUrl" alt="二维码">-->
      <!--<div class="text">-->
      <!--<p>-->
      <!--&lt;!&ndash;<img :src="wechatUrl" alt="">&ndash;&gt;-->
      <!--&lt;!&ndash;<span>微信搜索</span>&ndash;&gt;-->
      <!--</p>庆源绿色保理</div>-->
      <!--</div>-->
    </div>

    <div class="view-width">
      <!-- connect -->
      <el-row class="connect" :gutter="20">
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <el-row :gutter="20" class="ways">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="way"
              v-for="(item, index) in connectWays"
              :key="index"
            >
              <i class="icon" :class="[item.icon]"></i>
              <p class="text">{{ item.text }}</p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="code">
            <img class="code-img" :src="codeUrl" alt="二维码" />
            <div class="text">庆源绿色保理</div>
          </div>
        </el-col>
      </el-row>
      <!-- copyright -->
      <div class="copyright">
        <p>总部地址：深圳市福田区泰然大道东泰劲松大厦17C-3-3</p>
        <p>
          联系地址：内蒙古自治区呼和浩特市新城区万通路呼铁局火车头体育场院内西侧
        </p>
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >粤ICP备19150272号-1</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "custom-footer",
  data() {
    return {
      links: [
        [
          { name: "公司概况", href: "http://greenamc.com/index.php/about/1" },
          { name: "公司概况", href: "http://greenamc.com/index.php/about/2" },
          {
            name: "主要股东",
            href: "http://greenamc.com/index.php/about/2#zygd_box"
          },
          {
            name: "合作企业",
            href: "http://greenamc.com/index.php/about/2#hzjg_box"
          }
        ],
        [
          { name: "产品服务", href: "http://greenamc.com/index.php/list/6" },
          { name: "不良资产", href: "http://greenamc.com/index.php/list/7" },
          {
            name: "投资顾问",
            href: "http://greenamc.com/index.php/list/6#thyw_box"
          },
          {
            name: "普惠金融",
            href: "http://greenamc.com/index.php/list/6#phjr"
          },
          { name: "庆源保理", href: "http://www.qylsbl.com/bpsWeb/login" }
        ],
        [
          { name: "资产推介", href: "http://greenamc.com/index.php/list/11" },
          { name: "债权资产", href: "http://greenamc.com/index.php/list/12" }
        ],
        [
          { name: "新闻动态", href: "http://greenamc.com/index.php/list/14" },
          { name: "庆源资讯", href: "http://greenamc.com/index.php/list/15" },
          {
            name: "处置公告",
            href: "http://greenamc.com/index.php/list/14#czgg_box"
          }
        ],
        [
          { name: "联系我们", href: "http://greenamc.com/index.php/about/17" },
          {
            name: "呼和浩特",
            href: "http://greenamc.com/index.php/about/17#map1_box"
          },
          {
            name: "北京",
            href: "http://greenamc.com/index.php/about/17#map2_box"
          }
        ]
      ],
      connectWays: [
        {
          icon: "el-icon-phone",
          text: "联系电话：18682100214、15994792009"
        },
        {
          icon: "el-icon-message",
          text: "联系邮箱：business@qylsbl.com"
        }
      ]
    };
  },
  computed: {
    codeUrl() {
      // return "/file/code.jpg";
      return `${process.env.BASE_URL || "./"}file/code.jpg`;
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  margin-top: 20px;
  padding: 20px 0;
  text-align: center;
  background: #272d37;
  color: rgba(255, 255, 255, 0.6);

  .base-info {
    display: flex;
    justify-content: space-between;
    justify-content: center;

    .code {
      /*display: flex;*/
      .code-img {
        width: 120px;
        height: 120px;
      }
      .text {
        img {
          width: 40px;
        }
      }
    }
  }

  .connect {
    margin-bottom: 10px;

    .way {
      display: flex;
      margin-bottom: 20px;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: solid 1px #eee;
      }
    }

    .code {
      img {
        width: 120px;
        height: 120px;
      }
    }
  }

  .copyright {
    border-top: solid 1px #555;
    padding-top: 10px;
    font-size: 14px;
    line-height: 24px;

    a {
      text-decoration: none;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.links {
  width: 80%;
  display: flex;
  justify-content: center;
  li {
    width: 188px;
  }
  a {
    margin-bottom: 20px;
    display: block;
    color: #bbb;
    text-decoration: none;
    &:hover {
      color: #fff !important;
    }
  }
  a.link-title {
    margin-bottom: 25px;
    font-size: 18px;
  }
}
</style>
